import { Modal as AntModal } from "antd";
import { Typography } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

export default function CreditLimitExchaustModal({ visible, onClose }) {
  return (
    <AntModal
      visible={visible}
      onCancel={onClose}
      footer={null}
      centered
      closable={true}
      maskClosable={false}
      keyboard={false}
      bodyStyle={{
        textAlign: "center",
        padding: "32px",
        fontFamily: "Inter, sans-serif",
      }}
    >
      {/* Warning Icon */}
      <WarningAmberIcon sx={{ fontSize: 48, color: "#ff9800", mb: 1 }} />

      {/* Title */}
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        Job Posting Disabled
      </Typography>

      {/* Description */}
      <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        <p
          style={{
            fontSize: "1rem",
            lineHeight: 1.6,
            color: "#555",
            textAlign: "left",
          }}
        >
          Your branch has reached its credit limit.
        </p>

        <p
          style={{
            fontSize: "1rem",
            lineHeight: 1.6,
            color: "#555",
            textAlign: "left",
          }}
        >
          Please contact our finance team at{" "}
          <a
            href="mailto:finance@jobizo.com"
            style={{ color: "#007bff", textDecoration: "none" }}
          >
            finance@jobizo.com
          </a>{" "}
          to clear outstanding dues and continue posting shifts.
        </p>
      </div>
    </AntModal>
  );
}
